<div id="snapshotPdf" class="flex flex-col gap-2 f-s-12" style="max-width: 1000px; width: 100%; font-size: 12px; line-height: 1.5; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; zoom: reset; -webkit-text-size-adjust: 100%; -moz-text-size-adjust: 100%; text-size-adjust: 100%;">

    <mat-card-title>
      <div><span class="strong">License type:</span>&nbsp;&nbsp;&nbsp;&nbsp;Training Program</div>
      <div><span class="strong">Program Id:</span>&nbsp;&nbsp;&nbsp;{{trainingProgram.programId}}</div>
      <div><span class="strong">Date of application submission:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{trainingProgram.applicationDate}}</div>
      <div><span class="strong">Renewal number:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{trainingProgram.renewalCount}}
      </div>
    </mat-card-title>



    <mat-card-title>
      Getting Started Page
    </mat-card-title>
    <mat-card-content>
      <div class="flex flex-col gap-4 w-full lg:w-[70%]">
          <div class="w-full lg:w-[80%]">
            <span *ngIf="!trainingProgram.isRenewal">
              Thank you for your interest in applying for psilocybin facilitator training program curriculum approval
              using the Oregon Psilocybin Services Training Program, Licensing, and Compliance system (TLC).
            </span>
            <span *ngIf="trainingProgram.isRenewal">
              Thank you for your interest in applying to renew your psilocybin facilitator training program curriculum approval
              using the Oregon Psilocybin Services Training Program, Licensing, and Compliance system (TLC).
            </span>
          </div>

          <div class="w-full lg:w-[80%]">
            <span>
              Please note, the&nbsp;&nbsp;<strong>Responsible Party</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;for the training program should complete and sign this application.
              The Responsible Party must be an individual with legal authority to act on behalf of the program and
              who is legally responsible for the program. This person will also serve as the training program's
              primary contact during the training program application process and while the program is approved.
            </span>
          </div>

          <div class="w-full lg:w-[80%]">
            <span>
              When you click the continue button at the bottom of this page, you will proceed to the training program application.
              The application automatically saves in TLC. You may exit the application and come back later to complete and submit the application, if needed.
            </span>
          </div>

          <span>The completed application packet contains the following:</span>

          <div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span>
                  Completed and signed training program application
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span>
                  Copy of training program curriculum uploaded into the application when prompted
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
               <span class="strong">*</span>
                <span>
                  Completed curriculum worksheet in TLC
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span *ngIf="!trainingProgram.isRenewal">
                  $500 Non-refundable Training Program Application Fee
                </span>
                <span *ngIf="trainingProgram.isRenewal">
                  $500 Non-refundable Training Program renewal Application Fee
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span>
                  Payment Remittance Form (payment must clear before application will be reviewed)
                </span>
              </div>
            </div>
          </div>

          <div>Important Notes:</div>

          <div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span>
                  There can only be one active training program application per registered account
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span>
                  Please review each section of the application to ensure it is complete
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span>
                  Please provide proof that the training program has received and continues to hold any approvals required from the Higher Education Coordinating Commission (HECC)
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span *ngIf="!trainingProgram.isRenewal">
                  Toward the end of the application, a fee page will describe how to submit the application fee
                </span>
                <span *ngIf="trainingProgram.isRenewal">
                  Toward the end of the application, a fee page will describe how to submit the renewal application fee
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span *ngIf="showNewIncompleteDates(trainingProgram.applicationDate)" class="w-full md:w-[80%]">
                  <span class="strong">Paid Application Packets</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <u><em>&nbsp;&nbsp;&nbsp;Completed application packets</em></u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; will be reviewed by OPS to ensure all training program information
                  is provided and the curriculum meets the requirements in OAR 333-333-3005 to 333-333-3090. Upon review, if OPS determines
                  your curriculum is insufficient (example: missing required curriculum modules), we will notify you to give you an
                  opportunity to provide the missing information. You will have 30 days from the initial date you are notified to provide
                  the information necessary for your curriculum to be sufficient or your application will be denied. When OPS receives
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<u><em>incomplete application packets</em></u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (example: no curriculum is attached), OPS will notify you to give you an opportunity
                  to make your application complete. You have 30 days from the initial date you are notified to complete your application or it will be closed
                </span>
                <span *ngIf="!showNewIncompleteDates(trainingProgram.applicationDate)" class="w-full md:w-[80%]">
                  <span class="strong">Paid Application Packets</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <u><em>&nbsp;&nbsp;&nbsp;Completed application packets</em></u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; will be reviewed by OPS to ensure all training program information
                  is provided and the curriculum meets the requirements in OAR 333-333-3005 to 333-333-3090. Upon review, if OPS determines
                  your curriculum is insufficient (example: missing required curriculum modules), we will notify you to give you an
                  opportunity to provide the missing information. You will have 90 days from the initial date you are notified to provide
                  the information necessary for your curriculum to be sufficient or your application will be denied. When OPS receives
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<u><em>incomplete application packets</em></u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (example: no curriculum is attached), OPS will notify you to give you an opportunity
                  to make your application complete. You have 90 days from the initial date you are notified to complete your application or it will be closed
                </span>
              </div>
            </div>
            <div style="height: auto;" class="m-t-2">
              <div class="flex flex-row">
                <span class="strong">*</span>
                <span *ngIf="!trainingProgram.isRenewal">
                  <span class="strong">Unpaid Application Packets:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OPS will not review an application packet until the application fee is paid and cleared.
                </span>
                <span *ngIf="trainingProgram.isRenewal">
                  <span class="strong">Unpaid Application Packets:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OPS will not review an application packet until the renewal application fee is paid and cleared.
                </span>
              </div>
            </div>
          </div>

          <br>
          <div>
            <span class="strong">Psilocybin facilitator training programs must be licensed by the Higher Education Coordinating Commission (HECC).</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Under state law, career schools must be licensed by the HECC. See ORS 345.010 to 345.450. A career school is defined in
            state law as “any private proprietary professional, technical, home study, correspondence, business or other school instruction,
            organization or person that offers any instruction or training for the purpose or purported purpose of instructing, training or
            preparing persons for any profession.” ORS 345.010(3). OHA recommends that psilocybin training programs review the licensure
            laws related to career schools and contact the HECC if they have questions. OPS cannot make any determinations about whether
            HECC licensure is required, that is a decision that the HECC must make.
          </div>

          <div>
            <strong>For more information about HECC licensure, please see contact information below:</strong>
          </div>

          <div>
            <div class="flex flex-col">
              <span><u>For Private Career School License - Exemption Request & Student Complaints</u></span>
              <span [ngStyle]="{'max-width': sharedService.isMobile? '200px': '300px'}" style="word-wrap: break-word; white-space: normal">
                Matthew Altman - Phone (503) 881-2738</span>
              <span>

                  <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                    <span>
                      Matthew.ALTMAN&#64;hecc.oregon.gov</span>
                    <mat-icon>email</mat-icon>
                  </div>

              </span>
            </div>
          </div>

          <div>
            <div class="flex flex-col">
              <span><u>For Private Career School License- New school Licensure</u></span>
              <span [ngStyle]="{'max-width': sharedService.isMobile? '200px': '300px'}" style="word-wrap: break-word; white-space: normal">
                Peter Gertenrich - Phone (503) 551-8236</span>
              <span>

                  <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                    <span>
                      Peter.GERTENRICH&#64;hecc.oregon.gov</span>
                    <mat-icon>email</mat-icon>
                  </div>

              </span>
            </div>
          </div>

          <div>
            <div class="flex flex-col">
              <span><u>For Schools operating without a private career school license- Cease and Desist Letters</u></span>
              <span [ngStyle]="{'max-width': sharedService.isMobile? '200px': '300px'}" style="word-wrap: break-word; white-space: normal">
                Monika Peterson - Phone (503) 507- 8726</span>
              <span>

                  <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                    <span>
                      Monika.PETERSON&#64;state.or.us</span>
                    <mat-icon>email</mat-icon>
                  </div>

              </span>
            </div>
          </div>

          <div>
            <span class="strong">
                DISCLAIMER: Psilocybin remains a schedule I drug under the federal Controlled Substances Act. Applicants are
                responsible for making their own determinations regarding the legal risks associated with participating in this program.
                The information you provide in your application materials, including applicant and instructor names, is subject to
                disclosure under Oregon's public records laws
            </span>
          </div>
        </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Training Program Information Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">
      <!-- Program Information Section -->
      <div class="flex flex-col gap-2">

        <div class="flex flex-col gap-2">
          <span><strong>Your training program id</strong></span>
          <span>{{trainingProgram.programId}}</span>
        </div>

        <div class="flex flex-col gap-4">
          <span class="flex flex-row">
            <span class="k-icon" [ngClass]="trainingProgram.continuingEducation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
            <span class="text-wrap">Offering Continuing Facilitator Education Credits</span>
          </span>
        </div>

        <div class="flex flex-col gap-2">
          <span><strong>Program Name</strong></span>
          <span>{{trainingProgram.programName}}</span>
        </div>

        <div class="flex flex-col gap-2">
          <span><strong>Website</strong></span>
          <span>{{trainingProgram.website}}</span>
        </div>

        <div class="flex flex-col gap-2">
          <span><strong>What state, US territory, or freely associated state are you registered to do business in?</strong></span>
          <span>{{trainingProgram.registeredIn}}</span>
        </div>

        <div class="flex flex-col gap-2">
          <span><strong>Oregon Secretary of State Registration Number</strong></span>
          <span>{{trainingProgram.secretaryofStateNumber}}</span>
        </div>
      </div>

      <!--Program Physical Address-->
      <div class="flex flex-col">
        <span><strong>Program Headquarters/Main Office Physical Address</strong></span>
        <div class="m-t-8 flex flex-row gap-2">
          <span>{{trainingProgram.headquartersStreet}}</span>&nbsp;
          <span>{{trainingProgram.headquartersCity}}, </span>&nbsp;
          <span>{{trainingProgram.headquartersState}} </span>&nbsp;
          <span>{{trainingProgram.headquartersZip}} </span>&nbsp;
          <span>{{trainingProgram.headquartersCounty}}</span>
        </div>
      </div>

      <!--Program Mailing Address-->
      <div class="flex flex-col">
        <br>
        <span><strong>Program Headquarters/Main Office Mailing Address</strong></span>
        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="trainingProgram.mailingIsHeadquarters ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">Same as Headquarters</span>
        </span>
        <div class="m-t-8 flex flex-row gap-2 w-full" *ngIf="trainingProgram.mailingIsHeadquarters === false">
          <span>{{trainingProgram.mailingStreet}}</span>&nbsp;
          <span>{{trainingProgram.mailingCity}}, </span>&nbsp;
          <span>{{trainingProgram.mailingState}} </span>&nbsp;
          <span>{{trainingProgram.mailingZip}} </span>&nbsp;
          <span>{{trainingProgram.mailingCounty}}</span>
        </div>
      </div>

      <!--Program Facility Address-->
      <div class="flex flex-col">
        <br>
        <span><strong>In-Person Class Site Address</strong></span>
        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="trainingProgram.facilityIsHeadquarters ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">Same as Headquarters</span>
        </span>
        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="trainingProgram.facilityIsMailing ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">Same as Mailing</span>
        </span>
        <div class="m-t-8 flex flex-row gap-2 w-full" *ngIf="trainingProgram.facilityIsHeadquarters === false &&
                    trainingProgram.facilityIsMailing === false">
          <span>{{trainingProgram.facilityStreet}}</span>&nbsp;
          <span>{{trainingProgram.facilityCity}}, </span>&nbsp;
          <span>{{trainingProgram.facilityState}} </span>&nbsp;
          <span>{{trainingProgram.facilityZip}} </span>&nbsp;
          <span>{{trainingProgram.facilityCounty}}</span>
        </div>
      </div>

      <div *ngIf="trainingProgram.isRenewal">
        <div class="flex flex-row">
          <div class="flex flex-col gap-2">
            <span class="flex flex-row">
              <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I certify the information provided is true and complete to the best of my knowledge.
                I understand falsifying an application, supplying misleading information, or withholding information
                is grounds for denial of my application or revocation of my license.</span>
            </span>

          </div>
        </div>
      </div>

      <div *ngIf="trainingProgram.isRenewal" class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Please list any information on this page that is outdated or incorrect, but you are unable to change</strong></span>
            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{trainingProgram.trainingProgramInformationCorrectReason}}</span>
            </div>
            <span class="text-wrap">You are required to submit a Change Request to update the information you listed above. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
          </div>
        </div>
      </div>
    </mat-card-content>

<div class="page-break"></div>
  <!--Program Contacts-->

    <mat-card-title>
      Edit People Page
    </mat-card-title>
    <mat-card-content class="flex flex-col">
      <div class="flex flex-col gap-2 w-full">
        <span>
          Please provide the following information for the training program:
        </span>

        <div class="w-full">
          <u>Responsible Party</u> : individual must be legally authorized to make decisions and be legally responsible for the training program.
          This person will serve as the primary contact during the training program application process and while the program is approved.
          Providing the name, email address, and phone number for this individual is required. This person may also hold other roles in
          the training program such as Registered Agent or Training Program Director which can be indicated in the application.
        </div>

        <div class="w-full">
          <u>Registered Agent</u> : This individual must be authorized to accept legal service on behalf of the program and must be listed in any
          business registrations as the Registered Agent. Providing the name, email address, and phone number for this individual is required.
        </div>

        <div class="w-full">
          <u>Training Program Director</u> : This individual must be responsible for tracking student progress and have the authority to track student
          enrollment and confer program completion. Providing the name, email address, and phone number for this individual is required.
        </div>

        <div class="w-full">
          <u>Lead Educators</u> : These individuals are responsible for tracking the progress of students throughout the program. They must have
          sufficient experience, knowledge, skills and ability to competently train students in their assigned subject matter.
          They must understand the objectives of the training program and communicate effectively with students. They must demonstrate skill
          in instruction and student supervision. At least two lead educators must be identified for each training program.
          Providing the name, email address, and phone number for this individual is required.
        </div>

        <div class="w-full">
          <u>Instructors</u> : These individuals must have sufficient experience, knowledge, skills, and ability to competently train students
          in their assigned subject matter. They must understand the objectives of the training program and communicate effectively with students.
          They must demonstrate skill in instruction and student supervision. Only instructor names are required in the application.
        </div>

        <div class="w-full">
          <span>OAR 333-333 requires that beginning September 1, 2025, at least one instructor at a training program must hold a valid facilitator
            license in order for the training program to be approved or reapproved.</span>
        </div>

        <div class="flex flex-col">
          <span class="m-t-8">Facilitator Name: <strong>{{trainingProgram.facilitatorName}}</strong></span>
          <span class="m-b-8">Facilitator License: <strong>{{trainingProgram.facilitatorLicense}}</strong></span>
        </div>

        <span><strong>Important Note</strong></span>
        <div class="flex flex-row gap-2 w-full">
          <span>*</span>
          <span>You will be required to attest to the requirements met for each role as outlined in OAR 333-333-3020 and 333-333-3030. </span>
        </div>

        <div class="page-break"></div>

        <div class="flex flex-col gap-4 w-full">
          <div class="b-b-1 p-b-4 flex flex-row gap-2">
            <div class="w-[13%]"><strong>First Name</strong></div>
            <div class="w-[13%]"><strong>Last Name</strong></div>
            <div class="w-[12%]"><strong>Title</strong></div>
            <div class="w-[22%]"><strong>Roles</strong></div>
            <div class="w-[18%]"><strong>Email</strong></div>
            <div class="w-[13%]"><strong>Phone</strong></div>
            <div class="w-[9%]"><strong>Archived</strong></div>
          </div>
          <div *ngFor="let person of trainingProgram.trainingProgramContacts" class="flex flex-row gap-2">
            <div class="w-[13%]"><span class="break-all">{{person.firstName}}</span></div>
            <div class="w-[13%]"><span class="break-all">{{person.lastName}}</span></div>
            <div class="w-[12%]"><span class="break-all">{{person.title}}</span></div>
            <div class="w-[22%]">
              <div class="flex flex-col gap-1">
                <span *ngIf="person.isDirector">Training Program Director</span>
                <span *ngIf="person.isResponsible">Responsible Party</span>
                <span *ngIf="person.isBusinessAgent">Registered Agent</span>
                <span *ngIf="person.isLeadEducator">Lead Educator</span>
                <span *ngIf="person.isInstructor">Instructor</span>
              </div>
            </div>
            <div class="w-[18%]"><span class="break-all">{{person.email}}</span></div>
            <div class="w-[14%]"><span>{{person.phone | mask: '(000) 000-0000'}}</span></div>
            <div class="w-[8%]"><span class="break-all">{{person.archived ? 'Yes' : 'No'}}</span></div>
          </div>

          <br>
          <div *ngFor="let person of trainingProgram.trainingProgramContacts" class="flex flex-col gap-2">

            <div>{{person.firstName}} {{person.lastName}}&nbsp;&nbsp;
              <span *ngIf="person.isDirector">Training Program Director</span>&nbsp;&nbsp;
              <span *ngIf="person.isResponsible">Responsible Party</span>&nbsp;&nbsp;
              <span *ngIf="person.isInstructor">Instructor</span>&nbsp;&nbsp;
              <span *ngIf="person.isLeadEducator">Lead Educator</span>&nbsp;&nbsp;
              <span *ngIf="person.isBusinessAgent">Registered Agent</span>
            </div>

            <div class="flex flex-row" *ngIf="person.isDirector">
              <span class="k-icon"  [ngClass]="person.attestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">
                I certify and understand the training program director is responsible for student enrollment, tracking student progress and determining whether a student has successfully completed the training program.
              </span>
            </div>

            <div class="flex flex-row" *ngIf="person.isLeadEducator">
              <span class="k-icon"  [ngClass]="person.attestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">
                I certify that this training program lead educator has sufficient experience, knowledge, skills, and ability to competently train students in their assigned subject matter. I understand and have communicated to this lead educator that they must understand the objectives of the training program and communicate effectively with students. I understand that this lead educator must demonstrate skill in instruction and student supervision.
              </span>
            </div>

            <div class="flex flex-row" *ngIf="person.isInstructor">
              <span class="k-icon"  [ngClass]="person.attestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">
                I certify that this training program instructor has sufficient experience, knowledge, skills and ability to competently train students in their assigned subject matter. I understand and have communicated to the instructor that they must understand the objectives of the training program and communicate effectively with students. I understand that the instructor must demonstrate skill in instruction and student supervision.
              </span>
            </div>

            <br>
          </div>

        </div>
      </div>
    </mat-card-content>

    <mat-card-content>
      <div *ngIf="trainingProgram.isRenewal">
        <div class="flex flex-row">
          <div class="flex flex-col gap-2">
            <span class="flex flex-row">
              <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial of my application or revocation of my license.</span>
            </span>

          </div>
        </div>
      </div>
      <div *ngIf="trainingProgram.isRenewal" class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Please list any information on this page that is outdated or incorrect, but you are unable to change</strong></span>
            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{trainingProgram.peopleCorrectReason}}</span>
            </div>
            <span class="text-wrap">You are required to submit a Change Request to update the information you listed above. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
          </div>
        </div>
      </div>
    </mat-card-content>


  <div class="page-break"></div>

  <!--Curriculum-->

    <mat-card-title>Curriculum Page</mat-card-title>
    <mat-card-content class="flex flex-col gap-4">

      <div>Please provide a copy of your program's complete curriculum</div>

      <div class="flex flex-col gap-4 w-full pt-8">
        <div class="flex flex-row gap-2 b-b-1 p-b-4">
          <span style="width: 200px; word-wrap: break-word;"><strong>Name</strong></span>
          <span style="width: 150px;"><strong>Status</strong></span>
          <span style="width: 400px;"><strong>Comments</strong></span>
        </div>

        <div *ngFor="let document of this.trainingProgram.trainingProgramDocuments" class="flex flex-row gap-2 items-start pt-8">
          <span class="text-indigo-A400" style="width: 200px; word-wrap: break-word;">
            {{document.name}}
          </span>

          <span style="width: 150px;">
            <span *ngIf="trainingProgram.status !== sharedService.approved">Pending</span>
            <span *ngIf="document.types.includes(curriculumTypeId) && trainingProgram.status === sharedService.approved" class="text-light-green-600">Accepted</span>
            <span *ngIf="document.types.includes(curriculumUpdateTypeId) && trainingProgram.status === sharedService.approved" class="text-orange-900">Pending Approval</span>
            <span *ngIf="document.types.includes(deniedCurriculumTypeId) && trainingProgram.status === sharedService.approved" class="text-red-400">Not Accepted</span>
            <span *ngIf="document.types.includes(deprecatedCurriculumTypeId) && trainingProgram.status === sharedService.approved" class="text-red-400">Inactive</span>
          </span>

          <span style="width: 400px; word-wrap: break-word;">
            {{document.comments}}
          </span>
        </div>
      </div>

      <div class="flex flex-col gap-2 pt-8">
        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I certify the proposed hours of instruction meet the requirements of OAR 333-333-3050.</span>
        </span>

        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I certify the proposed course modules contain the content required by OAR 333-333-3060.</span>
        </span>

        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I certify the proposed practicum meets the requirements of OAR 333-333-3070.</span>
        </span>

        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand the requirements for accelerated training hours outlined in OAR 333-333-3080.</span>
        </span>

        <span class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand training programs must notify Oregon Psilocybin Services of any material changes
            to the curriculum and staff identified in their application.</span>
        </span>
        <span class="flex flex-row" *ngIf="trainingProgram.isRenewal">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or
                  withholding information is grounds for denial of my application or revocation of my license.</span>
        </span>
      </div>


      <div class="page-break"></div>

      <div class="f-s-20 pt-8">Curriculum Worksheet Page</div>

      <div class="flex flex-col md:flex-row gap-6">
          <span class="w-[70%]">Please provide the page references from your curriculum where each required module can be found.
          </span>
        </div>

      <div *ngFor="let element of curriculumMap; let elementIndex = index" class="flex flex-col w-full">
        <!--Core Elements-->
        <div class="flex flex-row gap-4 justify-start items-center">
          <span class="strong">({{elementIndex + 1}})</span>
          <br>
          <span>{{element.text}}</span>
          <br>
          <span class="ml-auto">{{element.hours}} hours</span>
        </div>
        <br>
        <!--Sub Sections-->
        <div class="flex flex-row">
          <!-- <span fxFlex="5"></span> -->
          <div class="flex flex-col w-full">
            <div *ngFor="let subSection of element.subSections; let subSectionIndex = index" class="flex flex-col gap-4">
              <div class="flex flex-row gap-4 justify-start items-center">
                <span class="flex-shrink-0 strong">({{getIndexLetter(subSectionIndex, false)}})</span>
                <br>
                <span class="flex-grow">{{subSection.text}}</span>
                <br>
                <span class="flex-shrink-0 strong">Pages: {{curriculumPageKey[subSection.referenceId]}}</span>
              </div>
              <br>
              <!--Secondary SubSections-->
              <div class="flex flex-col">
                <div class="flex flex-row">
                  <!-- <span fxFlex="5"></span> -->
                  <div class="flex flex-col w-full">
                    <div *ngFor="let secondSubSection of subSection.subSections; let secondaryIndex = index" class="flex flex-col">
                      <div class="flex flex-row gap-4 justify-start items-center">
                        <span class="flex-shrink-0 strong">({{getIndexLetter(secondaryIndex, true)}})</span>
                        <br>
                        <span class="flex-grow">{{secondSubSection.text}}</span>
                        <br>
                        <span class="flex-shrink-0 strong">Pages: {{curriculumPageKey[secondSubSection.referenceId]}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="trainingProgram.isRenewal">
        <div class="flex flex-row">
          <div class="flex flex-col gap-2">
            <span class="flex flex-row">
              <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I certify the information provided is true and complete to the best of my knowledge.
                I understand falsifying an application, supplying misleading information, or withholding information
                is grounds for denial of my application or revocation of my license.</span>
            </span>

          </div>
        </div>
      </div>

    </mat-card-content>


  <div class="page-break"></div>


    <mat-card-title>
      Fees Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-2">
      <div class="flex flex-col gap-4">

        <span *ngIf="!trainingProgram.isRenewal" >
          Non-Refundable Training Program Application Fee : $500.00
        </span>
        <span *ngIf="trainingProgram.isRenewal" >
          Non-Refundable Training Program Renewal Application Fee : $500.00
        </span>

        <span *ngIf="!trainingProgram.isRenewal" style="white-space: pre-wrap">
          The Training Program application will not be reviewed until payment has been received and cleared. After the Training Program application has been submitted, a “Pay Fee” button will be displayed. By clicking this button, payment information below will be displayed along with a downloadable payment remittance form to submit with your payment. A copy of this information will also be emailed to you after the application is submitted.
        </span>

        <span *ngIf="trainingProgram.isRenewal" style="white-space: pre-wrap">
          The Training Program renewal application will not be reviewed until payment has been received and cleared. After the Training Program renewal application has been submitted, a “Pay Fee” button will be displayed. By clicking this button, payment information below will be displayed along with a downloadable payment remittance form to submit with your payment. A copy of this information will also be emailed to you after the renewal application is submitted.
        </span>

        <span>Payment method options:</span>
        <ul>
          <li>Online</li>
          <li>Money Order</li>
          <li>Cashier's Check</li>
          <li>Personal/Business Check (personal and business checks are held for 21 days for clearance)</li>
          <li>Cash* <span class="strong">Please Do Not Mail Cash</span></li>
        </ul>

        <div *ngIf="!trainingProgram.isRenewal" class="flex flex-row items-start">
          <span><strong>Instructions for Submitting the Fee Payment by Mail or In-Person</strong></span>
        </div>

        <div *ngIf="trainingProgram.isRenewal" class="flex flex-row items-start">
          <span><strong>Instructions for Submitting the Fee Payment by Mail or In-Person</strong></span>
        </div>

        <span *ngIf="!trainingProgram.isRenewal">
          Money orders and checks are payable to: &nbsp;&nbsp;&nbsp;<span class="strong">Oregon Psilocybin Services</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Money orders and cashier's checks take less time to clear than personal and business checks.
          Personal and business checks are held for 21 days for clearance. Applications will be reviewed
          once payment has been cleared. Application fees are non-refundable.
        </span>

         <span *ngIf="trainingProgram.isRenewal">
          Money orders and checks are payable to: &nbsp;&nbsp;&nbsp;<span class="strong">Oregon Psilocybin Services</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Money orders and cashier's checks take less time to clear than personal and business checks.
          Personal and business checks are held for 21 days for clearance. Renewal applications will be reviewed
          once payment has been cleared. Renewal application fees are non-refundable.
        </span>

        <div class="flex flex-col">
          <span>
            <strong *ngIf="!trainingProgram.isRenewal">Mailing the application packet, money order or check, and remittance form:</strong>
            <strong *ngIf="trainingProgram.isRenewal">Mailing the renewal application packet, money order or check, and remittance form:</strong>
          </span>
          <span>Oregon Health Authority - Public Health Division - Fiscal Services</span>
          <span>RE: OPS</span>
          <span>PO Box 14260</span>
          <span>Portland, OR 97293-0260</span>
        </div>

        <div class="flex flex-col">
          <span><strong>In-person payment with a money order or check:</strong></span>
          <span>
            To make an in-person fee payment with a money order or check, print the remittance form and proceed to
            Cashier's Office on the second floor of the Portland State Office Building at 800 NE Oregon St, Suite 200,
            Portland, OR 97232 - Hours: 9am to 4pm, Mon to Fri
          </span>
        </div>

        <span>
          Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health Statistics window.
          If security asks if you have an appointment, you may let them know you are dropping off a payment for Oregon Psilocybin Services
          at the Cashier's Office window which does not require an appointment. Please include the remittance form with the payment.
        </span>

        <div class="flex flex-col">
          <span><strong>To make cash payment arrangements or for payment questions, please contact:</strong></span>
          <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">

              <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                <span>
                  licensing.psilocybin&#64;oha.oregon.gov </span>
                <mat-icon>email</mat-icon>
              </div>

            <span>or Licensing Inquiries: 1-971-673-0304</span>
          </div>
        </div>


      </div>
    </mat-card-content>



  <div class="page-break"></div>

  <!--Electronic Signature-->

    <mat-card-title>
      Review Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">

      <div class="flex flex-col gap-4 w-full">
        <div><strong>Review</strong></div>
        <div><strong>Program Information</strong></div>
        <div class="flex flex-col gap-2">
                  <div class="flex flex-col gap-4">
                    <span class="flex-1"><strong>Program Name</strong></span>
                    {{trainingProgram.programName}}
                  </div>
                  <div class="flex flex-col gap-4">
                    <span class="flex-1"><strong>Website</strong></span>
                    {{trainingProgram.website}}
                  </div>
                  <div class="flex flex-col gap-2">
                    <span class="flex-1"><strong>Headquarters Address</strong></span>
                    <div class="flex flex-row gap-4">
                      {{trainingProgram.headquartersStreet}}&nbsp;
                      {{trainingProgram.headquartersCity}}&nbsp;
                      {{trainingProgram.headquartersState}}&nbsp;
                      {{trainingProgram.headquartersZip}}&nbsp;
                      {{trainingProgram.headquartersCounty}}
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <span class="flex-1"><strong>Mailing Address</strong></span>
                    <div *ngIf="!trainingProgram.mailingIsHeadquarters" class="flex flex-row gap-4">
                      {{trainingProgram.mailingStreet}}&nbsp;
                      {{trainingProgram.mailingCity}}&nbsp;
                      {{trainingProgram.mailingState}}&nbsp;
                      {{trainingProgram.mailingZip}}&nbsp;
                      {{trainingProgram.mailingCounty}}
                    </div>
                    <span *ngIf="trainingProgram.mailingIsHeadquarters">Same as Headquarters</span>
                  </div>
                  <div class="flex flex-col gap-2">
                    <span class="flex-1"><strong>In Person Classes</strong></span>
                    <div *ngIf="!trainingProgram.facilityIsHeadquarters && !trainingProgram.facilityIsMailing" class="flex flex-row gap-4">
                      {{trainingProgram.facilityStreet}}&nbsp;
                      {{trainingProgram.facilityCity}}&nbsp;
                      {{trainingProgram.facilityState}}&nbsp;
                      {{trainingProgram.facilityZip}}&nbsp;
                      {{trainingProgram.facilityCounty}}
                    </div>
                    <span *ngIf="trainingProgram.facilityIsHeadquarters">Same as Headquarters</span>
                    <span *ngIf="trainingProgram.facilityIsMailing">Same as Mailing</span>
                  </div>
        </div>

        <div><strong>Curriculum</strong></div>
        <div *ngFor="let document of trainingProgram.trainingProgramDocuments">
          <div class="p-t-8 flex flex-col gap-2 w-full">
            <span class="text-indigo-A400 w-full md:w-[40%]">{{document.name}}</span>
            <span style="white-space: pre-wrap">{{document.comments}}</span>
          </div>
        </div>

        <div><strong>People</strong></div>
        <div class="flex flex-col gap-4 w-full" *ngIf="trainingProgram.trainingProgramContacts.length > 0">
        <div class="flex flex-row gap-2 b-b-1 p-b-4">
          <span style="width: 100px;"><strong>First Name</strong></span>
          <span style="width: 100px;"><strong>Last Name</strong></span>
          <span style="width: 100px;"><strong>Title</strong></span>
          <span style="width: 200px;"><strong>Roles</strong></span>
          <span style="width: 150px;"><strong>Email</strong></span>
          <span style="width: 120px;"><strong>Phone</strong></span>
          <span style="width: 150px;"><strong>Certifications</strong></span>
        </div>

        <div *ngFor="let contact of trainingProgram.trainingProgramContacts" class="flex flex-row gap-2 items-start pt-4 pb-4">
          <span style="width: 100px; word-wrap: break-word;">
            {{ contact.firstName }}
          </span>

          <span style="width: 100px; word-wrap: break-word;">
            {{ contact.lastName }}
          </span>

          <span style="width: 100px; word-wrap: break-word;">
            {{ contact.title }}
          </span>

          <div style="width: 200px;" class="flex flex-col">
            <span *ngIf="contact.isDirector">Director</span>
            <span *ngIf="contact.isResponsible">Legally Responsible Authorized Party</span>
            <span *ngIf="contact.isBusinessAgent">Business Registered Agent</span>
            <span *ngIf="contact.isLeadEducator">Lead Educator</span>
            <span *ngIf="contact.isInstructor">Instructor</span>
          </div>

          <span style="width: 150px; word-wrap: break-word; white-space: normal;">
            {{ contact.email }}
          </span>

          <span style="width: 120px;">
            {{ contact.phone | mask: '(000) 000-0000 0000' }}
          </span>

        </div>
      </div>
      </div>

      <div class="flex flex-col gap-4 w-full">

        <div><strong>Electronic Signature of Responsible Party</strong></div>

        <div class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">By completing and signing this application, I certify I am the Responsible Party, with legal authority to act on behalf of the training program,
            am legally responsible for the training program and will serve as the primary contact.</span>
        </div>

        <div class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I certify the information provided in this curriculum worksheet is true and complete to the best of my knowledge.
            I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial or revocation of approval.</span>
        </div>

        <div class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand applicants are responsible for making their own determinations regarding the legal risks associated with participating in this program.
            I understand much of the information provided in application materials, including applicant and instructor names, is subject to disclosure under
            Oregon's public records laws.</span>
        </div>

        <div class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand training programs must be located within the United States, US territories, or freely associated states.</span>
        </div>

        <div class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand the requirements for training program record keeping outlined in OAR 333-333-3040.</span>
        </div>

        <div class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand the requirements for training program completion and exams as outlined in OAR 333-333-3090.</span>
        </div>

        <div *ngIf="showFiveYear(trainingProgram.applicationDate)" class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand training program approval has a term of five years from the date of initial approval. If a training program wishes to be reapproved
            after that term, a training program must submit a new application, copy of program curriculum, payment,
            and curriculum worksheet for reapproval at least 30 days prior to their approval expiration.</span>
        </div>

        <div *ngIf="!showFiveYear(trainingProgram.applicationDate)" class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand training program approval has a term of one year from the date of initial approval. If a training program wishes to be reapproved
            after that term, a training program must submit a new application, copy of program curriculum, payment,
            and curriculum worksheet for reapproval at least 30 days prior to their approval expiration.</span>
        </div>

        <div class="flex flex-row">
          <span class="k-icon" [ngClass]="true ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I understand the training program application evaluation fee is non-refundable.</span>
        </div>

        <div class="flex flex-row gap-2 justify-start items-center">
          <span>Electronic Signature of Responsible Party: <strong>&nbsp;&nbsp;&nbsp;{{trainingProgram.electronicSignature}}</strong></span>
        </div>
      </div>
    </mat-card-content>


</div>
